import * as React from "react";
import { useData, useDataValue } from "../hooks/useData";
import { closestKey } from "../utils/dom";
import { toNumber } from "../utils/conversion";
import { Text, TextProps } from "./Text";
import { formatACN } from "../../formatters/format";


export function ACN(props: TextProps) {

    return (
		<Text
			{...props}
			onFormatValue={(value) => {
				if (!value) return "";

				return formatACN(value);	
			}}

			style={{maxWidth: "110px", textAlign: "center"}}
		/>
    );

}

